"use client";

import React from "react";
import { Check } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = ["Comprehensive Asset Audit", "Medical Standing Review", "Home Equity Flight Path", "Aircraft Transition Strategy", "Long-term Care Reserve Analysis"];
export default function PhaseITheAssessment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="260463" id="phase-i-the-assessment" className="py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex flex-col space-y-6">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-foreground tracking-tight">
              Phase I: The Comprehensive Assessment
            </h2>
            
            <p className="text-lg text-muted-foreground leading-relaxed font-default">
              Every successful mission begins with a thorough pre-flight inspection. Our Assessment phase is a technical audit of your current medical standing and financial assets. We analyze how your home equity, aircraft value, and retirement savings can be structured into a resilient flight plan that ensures you remain in command of your living situation for life.
            </p>

            <ul className="space-y-4 mt-4">
              {services.map((service, i) => <li key={i} data-index={i} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">
                    <div className="flex items-center justify-center w-6 h-6 rounded-md bg-primary/10 text-primary border border-primary/20">
                      <Check className="w-4 h-4" strokeWidth={3} />
                    </div>
                  </div>
                  <span className="text-base md:text-lg font-medium text-foreground font-default">
                    {service}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="relative w-full max-w-xl mx-auto lg:max-w-none">
            <div className="absolute -inset-4 bg-primary/5 rounded-md transform rotate-1 scale-105 -z-10 hidden md:block border border-primary/10"></div>
            <AspectRatio ratio={4 / 3} className="bg-muted rounded-md overflow-hidden shadow-xl border border-border">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689271/img/hangar_home_blueprint.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689271/img/hangar_home_blueprint.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689271/img/hangar_home_blueprint.png-wvc-sizes" alt="Technical blueprint of an airpark hangar home for asset assessment" className="object-cover w-full h-full transition-transform duration-700 hover:scale-105 grayscale-[0.2] contrast-[1.1]" loading="lazy" />
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>;
}